module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp8-9f57ab88cc07fc7dbcde3d811f6361ca.jpg";